<template>
  <el-dialog
    title="治疗费用"
    :loading="loading"
    :visible.sync="visible"
    :destroy-on-close="true"
    :close-on-click-modal="false"
    @close="closeDialog"
    width="1200px">
      <div v-if="['todo', 'timeout'].indexOf(active) > -1 && [0, 2].indexOf(rowData.outlayStatus) > -1" style="text-align: right; padding: 0 16px 16px 0; background: white;">
        <el-button :loading="loading" type="primary" icon="el-icon-success" size="mini" @click="giveUpData">放弃</el-button>
      </div>
      <div v-if="rowData.outlayStatus == 0" style="padding: 16px;">
        <CureOutlayDetail
          ref="outlayRef"
          :outlayId="rowData.outlayId"
          :belongProject="rowData.initialProject"
          :readOnly="true"
          @close="closeDialog"
          @success="formSaveSuccess">
        </CureOutlayDetail>
      </div>
      <el-tabs v-else v-model="localActive">
        <el-tab-pane label="费用信息" name="outlayInfo">
          <CureOutlayDetail
            ref="outlayRef"
            v-if="localActive == 'outlayInfo'"
            :outlayId="rowData.outlayId"
            :belongProject="rowData.initialProject"
            :readOnly="true"
            @close="closeDialog"
            @success="formSaveSuccess">
          </CureOutlayDetail>
        </el-tab-pane>
        <el-tab-pane label="审核记录" name="outlayHistory">
          <OutlayHistory v-if="localActive == 'outlayHistory'" :outlayId="rowData.outlayId"></OutlayHistory>
        </el-tab-pane>
      </el-tabs>
  </el-dialog>
</template>

<script>
import CureOutlayDetail from "./CureOutlayDetail";
import OutlayHistory from "./OutlayHistory";

export default {
  components: {
    CureOutlayDetail,
    OutlayHistory
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    active: {
      type: String,
      default: 'todo'
    },
    rowData: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      loading: false,
      localActive: 'outlayInfo'
    }
  },
  methods: {
    formSaveSuccess () {
      this.$emit('success')
    },
    closeDialog () {
      this.$emit('close')
    },
    giveUpData () {
      this.$refs.outlayRef.giveUpData();
    }
  }
}
</script>

<style lang="scss" scoped>
@import "src/common/dialog.scss";
</style>


// WEBPACK FOOTER //
// src/pages/outlay/view/CureOutlayDialog.vue